import React, { useEffect, useState } from 'react';
import { MSG } from "../constants/toastMessages";
import { useSelector } from "react-redux";
import { apiCallingPost } from '../api/services';
import { toast } from "react-toastify";
import Pagination from "react-js-pagination";
import ListReject from '../pages/home/list-reject';
import noData from "../assets/images/no-data.png"
import moment from 'moment';
import MediaPreview from '../components/MediaPreview';
import { FaImage } from "react-icons/fa";
import { FaVideo } from "react-icons/fa";
import DatePicker from "react-datepicker";
import { MdOutlineKeyboardArrowRight, MdOutlineStayCurrentLandscape, MdOutlineStayCurrentPortrait } from "react-icons/md";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { FiSearch } from "react-icons/fi";
import { LuSearchX } from "react-icons/lu";
function VideoUploadRequest() {
  const { userData } = useSelector((state) => state.masterData);
  const [destinationList, setDestinationList] = useState([]);
  const [destListTCount, setDestListTCount] = useState("");
  const [selectedVideos, setSelectedVideos] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [offset, setOffset] = useState(0);
  const [itemsCountPerPage, setItemsCountPerPage] = useState(10);
  const [popupReject, SetPopupReject] = useState(false)
  const [rejectData, setRejectData] = useState([])
  const [ImagePopup, setImagePopupFlag] = useState(false);
  const [popupSelectData, setPopupSelectData] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [fileType, setFileType] = useState("")
  const [searchInput, setSearchInput] = useState("")
  const [isRejectAllPopup, setIsRejectAllPopup] = useState(false);
  const [rejectText, setRejectText] = useState("");
  const [status, setStatus] = useState("")
  const [saveFlag, setSaveFlag] = useState(false);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        cancelPopup();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  useEffect(() => {
    setOffset(0);
    setActivePage(1);
    getData(0);
  }, [itemsCountPerPage])
  const rejectPopup = (data) => {
    setRejectData(data)
    SetPopupReject(true)
    document.body.style.overflow = 'hidden';
  }
  const popupTagShow = (data) => {
    setImagePopupFlag(true)
    setPopupSelectData(data)
    document.body.style.overflow = 'hidden';
  }
  const cancelPopup = () => {
    SetPopupReject(false)
    setImagePopupFlag(false)
    document.body.style.overflow = 'auto';
  }
  const getData = async (offsetNo) => {
    if (fileType && !searchInput) {
      // setLoading(false);
      toast.warn(MSG.searchTextRequired)
      return;
    }
    let postData = {
      userId: ["Super_admin", "APPROVER"].includes(userData?.roleDisplayName) ? "" : userData?.userId || "",
      offset: offsetNo,
      max: itemsCountPerPage,
      videoName: "",
      fromDate: "",
      toDate: "",
      videoApprovedStatus: status,
      requestedDate: startDate ? moment(startDate).format('YYYY-MM-DD') : "",
      type: fileType,//Video Name,Video Requested By Name
      textInput: searchInput,
      eventName: fileType == "Event Name" ? searchInput : "",
      location: fileType == "Locations" ? searchInput : "",
      is_processed:"",
      is_upload_request:true
    };
    try {

      const response = await apiCallingPost("api/video/videoList", postData);
      //  console.log("....response........",response);

      const { data } = response;
      if (data.success === "1") {
        setDestinationList(data.dataArray);
        setDestListTCount(data.totalCount);
      } else {
        setDestinationList([]);
        setDestListTCount("");
      }
    } catch (error) {
      console.error("Error fetching destination data:", error);
      setDestinationList([]);
      setDestListTCount("");
    }
  };

  const approveList = async (videoIds) => {
    const postData = {
      videoId: videoIds,
      userId: userData?.userId,
    };
    try {
      const response = await apiCallingPost("api/video/approveVideo", postData); // Adjusted endpoint
      const { data } = response;
      if (data.success === "1") {
        toast.success(MSG.mediaApproved);
        setSelectedVideos([])
        setTimeout(() => {
          getData(0); // Refresh data after approval
        }, 1000);
      } else {
        toast.error(MSG.genericError);
      }
    } catch (error) {
      console.error("Error approving videos:", error);
    }
  };
  const rejectList = async (videoIds) => {
    setSaveFlag(true)
    const postData = {
      videoId: videoIds,
      userId: userData?.userId,
      rejectReason: rejectText
    };
    try {
      const response = await apiCallingPost("api/video/rejectAll", postData); // Adjusted endpoint
      const { data } = response;
      
      if (data.success === "1") {
        toast.success(MSG.mediaRejected);
        setSelectedVideos([])
        rejectAllCancel();
        setRejectText("");
        // getData("", offset);
        setTimeout(() => {
          setSaveFlag(false)
          getData(0); // Refresh data after approval
        }, 1000);
      } else {
        toast.error(MSG.genericError);
      }
    } catch (error) {
      console.error("Error approving videos:", error);
    }
  };
  const handlePageChange = (pageNumber) => {
    let offsetNo = (pageNumber - 1) * itemsCountPerPage;
    setOffset(offsetNo);
    setActivePage(pageNumber);
    getData(offsetNo);
  };

  const handleCheckboxChange = (e, video_id) => {
    if (e.target.checked) {
      setSelectedVideos((prevList) => [...prevList, video_id]);
    } else {
      setSelectedVideos((prevList) => prevList.filter((id) => id !== video_id));
    }
  };

  const handleSelectAllChange = (e) => {
    const allCurrentPageIds = destinationList.map((item) => item.video_id);
    if (e.target.checked) {
      setSelectedVideos((prevList) => Array.from(new Set([...prevList, ...allCurrentPageIds])));
    } else {
      setSelectedVideos((prevList) => prevList.filter((id) => !allCurrentPageIds.includes(id)));
    }
  };

  const isAllChecked = () => {
    const allCurrentPageIds = destinationList.map((item) => item.video_id);
    return allCurrentPageIds.every((id) => selectedVideos.includes(id));
  };
  const handleAcceptAll = () => {
    if (selectedVideos.length < 1) {
      toast.error(MSG.selectToApprove);
      return;
    }
    approveList(selectedVideos, "APPROVED");
  };
  const handleRejectAll = () => {
    if (selectedVideos.length < 1) {
      toast.error(MSG.selectToReject);
      return;
    }
    else {
      setIsRejectAllPopup(true)
    }
    // approveList(selectedVideos, "APPROVED");
  }
  const rejectAllCancel = () => {
    setIsRejectAllPopup(false)
    setRejectText("")
  }
  const searchOnChange = (e) => {
    if (e.target.value === "") {
      setFileType(e.target.value)
      setSearchInput("")
    } else {
      setFileType(e.target.value)
    }
  }
  const clearSearch = (e) => {
    setFileType("")
    setSearchInput("")
    setStatus("")
    setStartDate("")
  }
  return (
    <>
      <div className='admin-toolbar tall'>
        <div className='container'>
          <div className='row w-100 g-3 video-list-filters-grid'>
            <div className='col-md-3 filter-column'>
              <div className='search-div'>
                <select className='search-input' value={fileType} aria-label="Default select example" onChange={searchOnChange}>
                  <option value="">Select type</option>
                  <option value="Video Name">Video Name</option>
                  <option value="Video Requested By Name">Video Requested By Name</option>
                  <option value="Event Name">Event Name</option>
                  <option value="Locations">Location Name</option>
                </select>
              </div>
            </div>
            <div className='col-md-3 filter-column'>
              <div className='search-div'>
                <input type='text' disabled={fileType !== "" ? false : true} value={searchInput} className='search-input search-input-default' placeholder='Search text'
                  onChange={(e) => setSearchInput(e.target.value)}
                />
              </div>
            </div>
            <div className='col-md-3 filter-column'>
              <div className='search-div'>
                <DatePicker selected={startDate} className='search-input search-input-picker' wrapperClassName='w-100' placeholderText="Date"
                  onChange={(date) => { setStartDate(date) }}
                  calendarClassName="custom-calendar"
                  dateFormat="dd/MM/yyyy"
                  renderCustomHeader={({
                    date, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled,
                  }) => (
                    <div className="custom-header">
                      <div className="custom-header-top">
                        <div className="day">
                          {date.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" })}
                        </div>
                      </div>
                      <div className="custom-month-nav">
                        <span className="month-year">
                          {date.toLocaleString("default", { month: "long" })} {date.getFullYear()}
                        </span>
                        <div>
                          <span onClick={decreaseMonth} disabled={prevMonthButtonDisabled} className="btn-picker">
                            <MdKeyboardArrowLeft color="#fff" size={25} />
                          </span>
                          <span onClick={increaseMonth} disabled={nextMonthButtonDisabled} className="btn-picker">
                            <MdOutlineKeyboardArrowRight color="#fff" size={25} />
                          </span>
                        </div>
                      </div>
                    </div>
                  )} />
              </div>
            </div>
            <div className='col-md-3 filter-column'>
              <div className='search-div'>
                <select className='search-input' aria-label="Default select example" value={status} onChange={(e) => setStatus(e.target.value)}>
                  <option value="">Status</option>
                  <option value="Approved">APPROVED</option>
                  <option value="Open">OPEN</option>
                  <option value="UnApproved">REJECTED</option>
                </select>
              </div>
              <div className='filter-actions-row'>
                <button type="button" className='search-icon-btn' onClick={() => getData(offset)}>
                  <FiSearch /> Search
                </button>
                <button type="button" className='search-icon-btn search-icon-clear' onClick={() => clearSearch()}>
                  <LuSearchX /> Clear
                </button>
              </div>
            </div>
          </div>
          {destListTCount > 0 && (
            <div className='admin-toolbar-bulk-actions'>
              <button className='accept-all-btn accept-all-danger' onClick={handleRejectAll}>Reject All</button>
              <button className='accept-all-btn' onClick={handleAcceptAll}>Approve All</button>
            </div>
          )}
        </div>
      </div>

      <div className='container mt-4'>
        {isRejectAllPopup &&
          <div className="modal-admin-wrapper multiple-upload" >
            <div className="modal-ad-popup modal-md">
              <div className="modal-innerpopup ">
                <div className="modal-headdiv d-flex justify-content-between">
                  <h5 className="modal-head w-100 text-center">Do you want to reject all?</h5>
                </div>
                <div className="form_div">
                  <textarea className="editTextInput" id="rejectText" placeholder="Reject reason" maxLength="120"
                    value={rejectText} onChange={(e) => setRejectText(e.target.value)}
                  ></textarea>
                </div>
              </div>
              <div className="tag-popup-footer">
                <div className="d-flex align-items-center gap-2">
                  <button type="button" className="accept-all-btn w-100 py-2 accept-all-gray" onClick={() => rejectAllCancel()}>
                    Cancel
                  </button>
                  <button type="button" disabled={saveFlag}
                    className="accept-all-btn w-100 py-2 d-flex align-items-center gap-2 justify-content-center"
                    onClick={() => rejectList(selectedVideos, "REJECTED")}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </div>
          </div>}
        {destListTCount > 0 ?
          <>
            <div className='table-responsive'>
              <table className="table table-bordered admin-list-table video-request-table">
                <thead>
                  <tr>
                    <th className='text-center' style={{ width: "50px" }}>
                      <div className="checkbox-wrapper-1 d-inline-block">
                        <input
                          id="select-all-upload"
                          className="substituted"
                          type="checkbox"
                          checked={isAllChecked()}
                          onChange={handleSelectAllChange}
                        />
                        <label htmlFor="select-all-upload"></label>
                      </div>
                    </th>
                    <th className='text-center' style={{ width: "50px" }}>#</th>
                    <th className='text-center' style={{ width: "70px" }}>Preview</th>
                    <th className='text-center' style={{ width: "90px" }}>Orientation</th>
                    <th className='col-md-5 col-xxl-6' style={{ minWidth: "200px", whiteSpace: 'nowrap' }}>Title</th>
                    <th className='text-center' style={{ width: "250px" }}>Admin Details</th>
                    <th className='text-center' style={{ width: "150px" }}>Date</th>
                    <th className='text-center' style={{ width: "180px" }}>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {destinationList.map((data, i) => (
                    <tr key={data.video_id}>
                      <td className='text-center'>
                        <div className="checkbox-wrapper-1 d-inline-block">
                          <input
                            type="checkbox"
                            id={`checkbox-${data.video_id}`}
                            className="substituted"
                            checked={selectedVideos.includes(data.video_id)}
                            onChange={(e) => handleCheckboxChange(e, data.video_id)}
                          />
                          <label htmlFor={`checkbox-${data.video_id}`}></label>
                        </div>
                      </td>
                      <td className='text-center'>{i + 1}</td>
                      <td className='text-center'>
                        {data.url && (
                          <button type="button" className='video-list-preview-btn' title="Preview"
                            onClick={() => popupTagShow(data)}>
                            {data.fileTypeId == "1"
                              ? <FaImage size={12} />
                              : <FaVideo size={12} />}
                          </button>
                        )}
                      </td>
                      <td className='text-center'>
                        {data.videoOrientation === "Horizontal" &&
                          <MdOutlineStayCurrentLandscape title="Horizontal" size={18} className='video-list-orient-icon' />}
                        {data.videoOrientation === "Vertical" &&
                          <MdOutlineStayCurrentPortrait title="Vertical" size={18} className='video-list-orient-icon' />}
                      </td>
                      <td style={{ wordBreak: "break-word" }}>
                        <div className='video-list-title-text'>{data.video_heading}</div>
                        {(data.eventName || data.video_location) && (
                          <p className='small text-muted mb-0'>
                            {data.eventName && <>Event: {data.eventName}</>}
                            {data.eventName && data.video_location && <> · </>}
                            {data.video_location && <>Location: {data.video_location}</>}
                          </p>
                        )}
                      </td>
                      <td className='text-center'>
                        <div>{data.userDisplayName}</div>
                        <div className='sub-text'>{data.userEmailId}</div>
                      </td>
                      <td className='text-center' style={{ whiteSpace: 'nowrap' }}>{data.videoCreatedOn}</td>
                      <td className='text-center'>
                        {data.approveStatus === "Open" ?
                          <div className='video-list-actions'>
                            <button type="button" className='action-btn-link' onClick={() => approveList([data.video_id])}>Accept</button>
                            <button type="button" className='action-btn-link action-btn-link--danger'
                              onClick={() => rejectPopup(data, i, `rejectBtn` + i, `reject-destination` + i)}>Reject</button>
                          </div>
                          :
                          <span className={`status-badge ${data.approveStatus === "Approved" ? "status-badge--approved"
                            : data.approveStatus === "UnApproved" || data.approveStatus === "Rejected" ? "status-badge--rejected"
                              : "status-badge--neutral"
                            }`}>
                            {data.approveStatus === "UnApproved" ? "Rejected" : data.approveStatus}
                          </span>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
          :
          <div className="noData d-flex flex-column">
            <div>
              <img src={noData} alt="noData" className="img-fluid" width="150" height="150" />
            </div>
            <div>No Data Available</div>
          </div>
        }
        <div className="d-flex align-items-center gap-3 flex-wrap justify-content-end my-4 page-division">
          <div className="ms-auto d-flex align-items-center gap-3 flex-wrap">
            <div className="d-flex align-items-center gap-2">
              Rows per page:
              <select value={itemsCountPerPage} style={{ minWidth: '60px' }} onChange={(e) => setItemsCountPerPage(e.target.value)}>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
            {Number(destListTCount) > Number(itemsCountPerPage) &&
              <div className='pagination-wrapper m-0 p-0'>
                <Pagination
                  activePage={activePage}
                  itemsCountPerPage={itemsCountPerPage}
                  totalItemsCount={destListTCount}
                  pageRangeDisplayed={5}
                  onChange={(e) => handlePageChange(e)}
                />
              </div>
            }
          </div>
        </div>
        <MediaPreview
          open={ImagePopup}
          url={popupSelectData.url}
          fileType={popupSelectData.fileTypeId}
          qualityTypeArray={popupSelectData.qualityTypeArray}
          poster={popupSelectData.thumbnail_image}
          autoPlay
          onClose={cancelPopup}
        />
        {popupReject &&
          <ListReject rejectData={rejectData} userData={userData}
            cancelPopup={cancelPopup} getData={() => getData(0)}
          />
        }
      </div>
    </>
  );
}

export default VideoUploadRequest;
